import { useMutation } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { HcfOperationalReportApi } from '../../../apis/HcfOperationalReportApi/HcfOperationalReportApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError';
import { downloadBlob } from '../../../helpers/downloadBlob';

export function useDownloadHcfOperationalReport() {
    const { t } = useTranslation();

    return useMutation<Blob, AppMedError, { healthcareFacilityId: number }>({
        mutationKey: [QueryKeys.healthcareFacility, 'downloadOperationalReport'],
        mutationFn: async ({ healthcareFacilityId }) => {
            return await HcfOperationalReportApi.downloadPdf(healthcareFacilityId);
        },
        onSuccess: (blob, { healthcareFacilityId }) => {
            const filename = `HcfOperationalReport_Facility${healthcareFacilityId}_${new Date().toISOString().split('T')[0]}.pdf`;
            downloadBlob(blob, filename);

            notifications.show({
                title: t('hcfOperationalReport.notifications.downloadSuccess.title'),
                message: t('hcfOperationalReport.notifications.downloadSuccess.message'),
                color: 'green',
            });
        },
        onError: (error: AppMedError) => {
            notifications.show({
                title: t('hcfOperationalReport.notifications.downloadError.title'),
                message: error?.message || t('hcfOperationalReport.notifications.downloadError.message'),
                color: 'red',
            });
        },
    });
}
